import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BannerAdDisplay = ({ position }) => {
  const [bannerAds, setBannerAds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBannerAds();
  }, [position]);

  const fetchBannerAds = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/banner-ads/${position}`);
      setBannerAds(response.data);
    } catch (error) {
      console.error('Error fetching banner ads:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="w-full max-w-[300px] h-[250px] bg-gray-800 rounded-lg flex items-center justify-center">
        <div className="text-white/50 text-sm">Loading ads...</div>
      </div>
    );
  }

  if (bannerAds.length === 0) {
    return null; // Don't show anything if no ads
  }

  // Show the first active ad
  const ad = bannerAds[0];

  return (
    <div className="w-full max-w-[300px]" data-testid={`banner-ad-${position}`}>
      <div className="mb-2">
        <span className="text-xs text-white/50">Advertisement</span>
      </div>
      <div 
        className="bg-gray-900 rounded-lg overflow-hidden border border-white/10"
        style={{ width: `${ad.width}px`, height: `${ad.height}px` }}
      >
        <iframe
          src={ad.iframe_url}
          width={ad.width}
          height={ad.height}
          frameBorder="0"
          scrolling="no"
          title={`Banner Ad - ${ad.name}`}
          className="w-full h-full"
          onError={(e) => {
            console.error('Banner ad iframe failed to load:', e);
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
        
        {/* Fallback content if iframe fails */}
        <div className="w-full h-full bg-gradient-to-br from-purple-900/50 to-pink-900/50 flex items-center justify-center text-white/70 text-sm hidden">
          <div className="text-center">
            <div className="text-2xl mb-2">📺</div>
            <div>Advertisement</div>
            <div className="text-xs mt-1">{ad.name}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerAdDisplay;